import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import {
  mapDocToPublicListing,
  PublicListing,
  PublicListingCollection,
} from "../types/PublicListing";

export function usePublicListing(projectId: string | null) {
  const [publicListing, setPublicListing] = useState<PublicListing | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    const unsubscribe = onSnapshot(
      doc(firestore, PublicListingCollection, projectId),
      (docSnap) => {
        try {
          if (docSnap.exists()) {
            setPublicListing(mapDocToPublicListing(docSnap.id, docSnap.data()));
          } else {
            setPublicListing(null);
          }
          setIsLoading(false);
          setError(null);
        } catch (err) {
          setError("Failed to load public listing");
          setPublicListing(null);
          setIsLoading(false);
        }
      },
    );

    return () => unsubscribe();
  }, [projectId]);

  return useMemo(
    () => ({ publicListing, isLoading, error }),
    [publicListing, isLoading, error],
  );
}
